export const ChannelType = {
  // MobilePushNotifications: 1, TODO: not implemented
  // WhatsappForRegisteredUsers: 2, TODO: not implemented
  'Whatsapp (Unregistered users)': 3,
};

export const MessageCampaignType = {
  Engagement: 'engagement', // TODO: add more types according to the enum in the backend
};

export const UnregisteredEmployeeFields = {
  companyName: 'חברה',
  firstName: 'שם פרטי',
  lastName: 'שם משפחה',
  employeeName: 'שם מלא',
  govId: 'מספר ת.ז',
  dob: 'תאריך לידה',
  phoneNumber: 'מספר טלפון',
  branch: 'סניף',
  employeeId: 'מס עובד',
  subsidiary: 'subsidiary',
};

// WhatsApp template header formats that carry media. Mirrors the backend check in
// whatsapp.service.ts (buildHeaderMediaComponent) — a template whose HEADER component has one of
// these formats must be sent with a mediaUrl, and any other template must be sent without one.
export const MediaHeaderTypeLabels = {
  IMAGE: 'תמונה',
  VIDEO: 'וידאו',
  DOCUMENT: 'קובץ',
};

export const normalizeHeaderType = (headerType) => String(headerType || '').toUpperCase();

export const isMediaHeaderType = (headerType) =>
  Object.keys(MediaHeaderTypeLabels).includes(normalizeHeaderType(headerType));

// Kept in step with shared-libs/src/campaign-media.ts in the backend, which is the source of
// truth. The browser just fails faster and with a friendlier message; the server decides.
//
// The limits are Meta's: https://developers.facebook.com/docs/whatsapp/cloud-api/reference/media
// Images are capped at 5MB there, videos and documents at 16MB — one flat ceiling would let an
// oversized image through every check and only fail when WhatsApp refused to fetch it.
export const MediaAcceptedMimeTypes = {
  IMAGE: ['image/jpeg', 'image/png', 'image/svg+xml'],
  VIDEO: ['video/mp4', 'video/3gpp'],
  DOCUMENT: ['application/pdf'],
};

const MB = 1024 * 1024;

export const MediaMaxSizeBytes = {
  IMAGE: 5 * MB,
  VIDEO: 16 * MB,
  DOCUMENT: 16 * MB,
};

export const mediaMaxSizeBytesFor = (headerType) =>
  MediaMaxSizeBytes[normalizeHeaderType(headerType)] ?? 16 * MB;

export const mediaMaxSizeMbFor = (headerType) => mediaMaxSizeBytesFor(headerType) / MB;

export const mediaAcceptedMimeTypesFor = (headerType) =>
  MediaAcceptedMimeTypes[normalizeHeaderType(headerType)];
